import React from "react";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import {Button} from "reactstrap";
import {Objects} from "components";
import PropTypes from "prop-types";
import UniversalModalOverride from "components/UniversalModalOverride";
import ObjectOverride from "components/ObjectOverride";
import APPCONFIG from "constants/Config";


/**
 *  @property {Point_Of_Sales_Object} state
 *  @property {object} model
 *  @property {Point_Of_Sales_Properties} model.properties
 *  @property {Point_Of_Sales_Is} model.is
 *  @property {Point_Of_Sales_Has} model.has
 */
export default class PointOfSale extends ObjectOverride {

	static propTypes = {
		locations: PropTypes.array,
	};

	constructor(props) {
		super(props, Types.Point_Of_Sales._name);

		this.state.modalPOS = false;
		let devness = APPCONFIG.settings.apiURL() === 'https://dev.api.fflboss.com' ? 'dev.' : (APPCONFIG.settings.apiURL() === "https://beta.api.fflboss.com" ? "beta." : "") ;
		let url = "https://" + devness + "pos.karlstechnology.com";
		window.open(url, "_blank");
		this.props.history.push("/");
	}

	/**
	 * @param prevProps
	 * @param {Point_Of_Sales_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		/** @type {Point_Of_Sales_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name_first + " " + object.name_last);
		}
	}

	render() {
		return (
			<Card>
				<CardContent style={{paddingBottom: 0}}>
					<div className="row justify-content-md-center">
						<div className="col-lg-10">

							<div className="row">
								<div className="col-md-4">
									<span className="text-center"
									      style={{marginTop: '20px', display: 'block', paddingBottom: '25px'}}>
										<img src="/assets/images/ffl-integration.png" style={{width: '400px'}}
										     alt={'FFL Boss Integration'}/>
									</span>
								</div>
								<div className="col-md-8">
									<h3>FFL Boss Integration</h3>
									<p>Point of Sale is able to directly integrate with FFL Boss allowing you to
										maintain a
										single firearms list between the two products.</p>
								</div>
							</div>
							<hr/>
							<div className="row">
								<div className="col-md-8">
									<h3>Z11 With Chip Integration</h3>
									<p>Compatible with Dejavoo Z11 counter top touch screen card terminal. The Z11
										supports
										WiFI connectivity and has EMV and NFC Contactless built in.</p>
								</div>
								<div className="col-md-4">
									<span className="text-center"
									      style={{display: 'block', paddingTop: '10px', paddingBottom: '10px'}}>
										<img src="/assets/images/dejavoo-z11.jpg" style={{width: '200px'}}
										     alt={'Z11 Support'}/>
									</span>
								</div>
							</div>
							<hr/>
							<div className="row">
								<div className="col-md-4">
									<span style={{display: 'block', paddingTop: '10px', paddingBottom: '10px'}}>
										<img src="/assets/images/blue-dog-logo.svg" style={{width: '200px'}}
										     alt={'Blue Dog'}/>
									</span>
									<span style={{display: 'block', paddingTop: '10px', paddingBottom: '10px'}}>
										<img src="/assets/images/trans-national.png" style={{width: '200px'}}
										     alt={'Trans National'}/>
									</span>
									<span style={{display: 'block', paddingTop: '10px', paddingBottom: '10px'}}>
										<img src="/assets/images/fluid-pay.svg" style={{width: '200px'}}
										     alt={'Fluid Pay'}/>
									</span>
								</div>
								<div className="col-md-8">
									<h3>BlueDog and TransNational</h3>
									<p>Support for BlueDog, TransNational and Fluidpay.com credit card processing
										networks.</p>
								</div>
							</div>
							<hr/>
							<div className="row">
								<div className="col-md-8">
									<h3>Fast and Easy Checkout</h3>
									<p>With our fast checkout process it is a breeze to run automatic, manual, check,
										and
										cash transactions.</p>
								</div>
								<div className="col-md-4">
									<span className="text-center"
									      style={{display: 'block', paddingBottom: '30px', marginTop: '20px'}}>
										<img src="/assets/images/checkout.PNG" style={{width: '400px'}}
										     alt={'Checkout Image'}/>
									</span>
								</div>
							</div>

						</div>
					</div>
					<hr style={{marginBottom: 0}}/>
					<h4>Find out about the new Point of Sale Today</h4>
					<p>Request information on how to integrate your FFL Boss account with our new Point of Sale.</p>
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				<CardActions>
					<Button
						color="primary"
						data-id={'pos-submit'}
						onClick={this.toggle('modalPOS')}>
						<i className="fa fa-paper-plane"/>
						&nbsp;&nbsp;Submit Request
					</Button>

					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						history={this.props.history}
						name={"Contact"}
						object={Objects.PointOfSaleContact}
						toggle={this.state.modalPOS}
						reportClose={this.reportClose('modalPOS')}
					/>
				</CardActions>
			</Card>
		)
	}
}
